import { resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-38db8147")

_pushScopeId("data-v-38db8147")
const _hoisted_1 = { class: "w-full flex flex-row mb-3 md:mb-0" }
const _hoisted_2 = { class: "font-bold w-24 pr-1 md:pr-0 md:w-auto" }
const _hoisted_3 = { class: "flex flex-1" }
const _hoisted_4 = { class: "flex flex-col px-1 mt-1 flex-shrink-0" }
const _hoisted_5 = { class: "flex items-center justify-center" }
const _hoisted_6 = { class: "flex items-center justify-center timeline-mobile" }
const _hoisted_7 = { class: "pl-2 flex-1 min-w-0" }
const _hoisted_8 = { class: "flex flex-col w-full" }
const _hoisted_9 = { class: "p-3 rounded-lg border border-gray-lp-900 w-full mt-1 flex items-center justify-between" }
const _hoisted_10 = { class: "flex-1 min-w-0" }
const _hoisted_11 = { class: "flex md:items-center items-baseline flex-col md:flex-row mt-1 md:mt-0" }
const _hoisted_12 = { class: "flex flex-row items-center" }
const _hoisted_13 = { class: "flex flex-row mt-2 md:mt-0 items-center" }
const _hoisted_14 = { class: "w-5 flex" }
const _hoisted_15 = {
  key: 0,
  class: "flex"
}
const _hoisted_16 = {
  class: `text-12px font-normal text-gray-lp-800`,
  onClick: ""
}
const _hoisted_17 = { class: "flex items-center gap-1" }
const _hoisted_18 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "" }, "•", -1)
const _hoisted_20 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_21 = { class: "flex" }
const _hoisted_22 = {
  class: `text-12px font-normal text-gray-lp-600`,
  onClick: ""
}
const _hoisted_23 = { class: "flex" }
const _hoisted_24 = {
  class: `text-12px font-normal text-gray-lp-600`,
  onClick: ""
}
const _hoisted_25 = { class: "flex items-center gap-2" }
const _hoisted_26 = {
  key: 0,
  class: "flex items-center gap-1.5"
}
const _hoisted_27 = { class: "font-semibold" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "border-r border-gray-lp-600 w-px h-3" }, null, -1)
const _hoisted_29 = {
  key: 1,
  class: "flex items-center gap-1.5"
}
const _hoisted_30 = { class: "font-semibold" }
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "border-r border-gray-lp-600 w-px h-3" }, null, -1)
const _hoisted_32 = {
  key: 2,
  class: "flex items-center gap-1.5"
}
const _hoisted_33 = { class: "font-semibold" }
const _hoisted_34 = {
  key: 1,
  class: "flex gap-1 mt-1"
}
const _hoisted_35 = { class: "rounded-2xl px-2 py-0.5 bg-gray-lp-1100 text-xs text-gray-lp-300" }
const _hoisted_36 = {
  key: 2,
  class: "flex gap-1 mt-1"
}
const _hoisted_37 = { class: "rounded-2xl px-2 py-0.5 bg-gray-lp-1100 text-xs text-gray-lp-300" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" transit ")
const _hoisted_39 = { class: "font-semibold" }
const _hoisted_40 = {
  key: 0,
  class: "flex items-center gap-4 p-6 rounded-b-lg border-l border-r border-b border-gray-lp-900 -mt-1 w-full"
}
const _hoisted_41 = {
  key: 0,
  class: "text-xs font-bold text-gray-lp-800"
}
const _hoisted_42 = { class: "flex flex-col items-center" }
const _hoisted_43 = { class: "font-semibold border-b border-gray-lp-1400 px-4 pb-1 text-xs text-gray-lp-800" }
const _hoisted_44 = { class: "text-gray-lp-3005 mt-1 font-medium text-xs" }
const _hoisted_45 = { class: "text-xs font-bold text-gray-lp-800" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TooltipV2 = _resolveComponent("TooltipV2")!
  const _component_Icons = _resolveComponent("Icons")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: `w-24 pr-3 text-12px ${
        _ctx.active ? 'text-gray-lp-300' : 'text-gray-lp-800'
      }  text-right mt-1`
    }, [
      _withDirectives(_createVNode("div", _hoisted_2, null, 512), [
        [_directive_sanitize_html, _ctx.formatTime(_ctx.dateTime)]
      ])
    ], 2),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", {
            class: `w-4 h-4 ${
              _ctx.active ? 'bg-red-lp-300' : 'bg-gray-lp-1300'
            }  rounded-full`
          }, null, 2)
        ]),
        _createVNode("div", _hoisted_6, [
          (_ctx.isVerticalLine)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: [
              'w-0.5 border-2 border-gray-lp-1300 my-1 rounded-md vertical-line-mobile',
              { 'h-16': _ctx.flightCode || _ctx.flightTime, 'h-12': !(_ctx.flightCode || _ctx.flightTime) }
            ]
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isHalfVerticalLine)
            ? (_openBlock(), _createBlock("div", {
                key: 1,
                class: `w-0.5 h-full md:h-2 border-2 border-gray-lp-1300 my-1 rounded-md vertical-line-mobile`
              }, null, 2))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, [
                  _createVNode("div", {
                    class: 
                      `text-12px font-bold ${
                        _ctx.active ? 'text-gray-lp-300' : 'text-gray-lp-800'
                      }`
                    
                  }, _toDisplayString(_ctx.status), 3),
                  _createVNode(_component_TooltipV2, {
                    description: _ctx.tooltip,
                    adjustedPosition: "flex items-center",
                    icon: "info",
                    text: "‎"
                  }, null, 8, ["description"])
                ]),
                _createVNode("div", {
                  class: 
                    `hidden md:flex text-16px pl-1 font-bold ${
                      _ctx.active ? 'text-gray-lp-300' : 'text-gray-lp-800'
                    }`
                  
                }, " I ", 2),
                _createVNode("div", _hoisted_13, [
                  _createVNode("div", _hoisted_14, [
                    _createVNode(_component_Icons, {
                      name: "maps",
                      class: 
                        `w-5 md:pl-1 ${
                          _ctx.active ? 'text-gray-lp-300' : 'text-gray-lp-800'
                        }`
                      
                    }, null, 8, ["class"])
                  ]),
                  _createVNode("div", {
                    class: 
                      `ml-2 md:ml-0 text-12px font-medium ${
                        _ctx.active ? 'text-gray-lp-300' : 'text-gray-lp-800'
                      }`
                    ,
                    innerHTML: _ctx.transitLocation
                  }, null, 10, ["innerHTML"])
                ])
              ]),
              (_ctx.isFlightDeparted || _ctx.isFlightArrived)
                ? (_openBlock(), _createBlock("div", _hoisted_15, [
                    _createVNode("div", _hoisted_16, [
                      _createVNode("div", _hoisted_17, [
                        (_ctx.flightCode)
                          ? (_openBlock(), _createBlock("div", _hoisted_18, _toDisplayString(_ctx.flightCode), 1))
                          : _createCommentVNode("", true),
                        _hoisted_19,
                        (_ctx.flightDateTime)
                          ? (_openBlock(), _createBlock("div", _hoisted_20, _toDisplayString(_ctx.formatFlightDateTime(_ctx.flightDateTime)), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_21, [
                _createVNode("div", _hoisted_22, [
                  _withDirectives(_createVNode("div", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickValue && _ctx.onClickValue(...args)))
                  }, null, 512), [
                    [_directive_sanitize_html, _ctx.description]
                  ]),
                  (_ctx.proofPod)
                    ? (_openBlock(), _createBlock("a", {
                        key: 0,
                        class: "text-red-lp-300 font-normal cursor-pointer hover:underline",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickValue && _ctx.onClickValue(...args)))
                      }, _toDisplayString(_ctx.$t("cargo.v2.history.link.deliveryProof")), 1))
                    : _createCommentVNode("", true),
                  (_ctx.proofAdjustBook)
                    ? (_openBlock(), _createBlock("a", {
                        key: 1,
                        class: "text-red-lp-300 font-normal cursor-pointer hover:underline",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickValue && _ctx.onClickValue(...args)))
                      }, _toDisplayString(_ctx.$t("cargo.v2.history.link.weightChangePhoto")), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_23, [
                _createVNode("div", _hoisted_24, [
                  _createVNode("div", _hoisted_25, [
                    (_ctx.koli > 0)
                      ? (_openBlock(), _createBlock("div", _hoisted_26, [
                          _createTextVNode(_toDisplayString(_ctx.$t("cargo.v2.history.field.coliCount")), 1),
                          _createVNode("span", _hoisted_27, _toDisplayString(_ctx.koli), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_28,
                    (_ctx.grossWeight > 0)
                      ? (_openBlock(), _createBlock("div", _hoisted_29, [
                          _createTextVNode(_toDisplayString(_ctx.$t("cargoV2.components.detailHistory.grossWeight")) + " ", 1),
                          _createVNode("span", _hoisted_30, _toDisplayString(_ctx.grossWeight) + "kg", 1)
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_31,
                    (_ctx.volumeWeight > 0)
                      ? (_openBlock(), _createBlock("div", _hoisted_32, [
                          _createTextVNode(_toDisplayString(_ctx.$t("cargoV2.components.detailHistory.volumeWeight")) + " ", 1),
                          _createVNode("span", _hoisted_33, _toDisplayString(_ctx.volumeWeight) + "kg", 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              (_ctx.totalTransit === 0)
                ? (_openBlock(), _createBlock("div", _hoisted_34, [
                    _createVNode("div", _hoisted_35, _toDisplayString(_ctx.$t("cargo.v2.history.direct")), 1)
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_36, [
                    _createVNode("div", _hoisted_37, _toDisplayString(_ctx.totalTransit), 1),
                    _hoisted_38
                  ]))
            ]),
            (_ctx.totalTransit >= 0)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  class: "flex items-center flex-shrink-0 ml-auto whitespace-nowrap",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleAccordion && _ctx.toggleAccordion(...args)))
                }, [
                  _createVNode("div", _hoisted_39, _toDisplayString(_ctx.isAccordionOpen ? _ctx.$t("cargo.v2.history.close") : _ctx.$t("cargo.v2.history.flightDetails")), 1),
                  _createVNode("img", {
                    src: 
                  require(`@/app/ui/assets/svg/chevron-${
                    _ctx.isAccordionOpen ? 'up' : 'down'
                  }.svg`)
                ,
                    alt: _ctx.isAccordionOpen ? 'chevron-up' : 'chevron-down',
                    class: "w-4 ml-1"
                  }, null, 8, ["src", "alt"])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isAccordionOpen)
            ? (_openBlock(), _createBlock("div", _hoisted_40, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cargoFlightDetails, (flightDetail, index) => {
                  return (_openBlock(), _createBlock("div", {
                    key: `flight-detail-${index}`,
                    class: "flex items-center gap-4"
                  }, [
                    (index === 0)
                      ? (_openBlock(), _createBlock("div", _hoisted_41, _toDisplayString(flightDetail.cfAirportOrigin), 1))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_42, [
                      _createVNode("div", _hoisted_43, _toDisplayString(flightDetail.cfFlightNo), 1),
                      _createVNode("div", _hoisted_44, _toDisplayString(_ctx.getFlightTime(flightDetail.cfEstDepartureTime)) + "/" + _toDisplayString(_ctx.getFlightTime(flightDetail.cfEstArrivalTime)), 1)
                    ]),
                    _createVNode("div", _hoisted_45, _toDisplayString(flightDetail.cfAirportDestination), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
})